import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { addPaymentError } from '../reducers';

export default function useSyncPaymentOptionsError(isError: boolean) {
    const dispatch = useDispatch();
    const { t } = useTranslation(['payment']);

    useEffect(() => {
        if (!isError) {
            return;
        }

        dispatch(addPaymentError({ message: t('payment.paymentForm.paypalPlusFetchError') }));
    }, [isError]);
}
